module.exports = __webpack_public_path__ + "img/geraldo-rufino.351d1b53.jpg";